// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Ne_l","title":"ClientReferral_title__uc_zF","itemText":"ClientReferral_itemText__3sCJi"};